module.exports = __webpack_public_path__ + "img/ruzhuzhong.f3dbeac4.png";